import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { GlobalErrorHandler } from '..'

export class MerchantApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getMerchants = async (
    searchValues = [] as string[],
    guids = [] as string[],
    page = 1,
    perPage = 25,
  ) => {
    let url = ApiEndpoints.MERCHANTS
    url += `?page=${page}&per_page=${perPage}`

    if (searchValues.length) {
      searchValues.forEach((value) => (url += `&fuzzy_name[]=${value}`))
    }

    if (guids.length) {
      guids.forEach((guid) => (url += `&guid[]=${guid}`))
    }

    return this.fetchInstance.get(url).then((data) => data.merchants)
  }

  getMerchantByGuid = async (guid: string) => {
    return this.fetchInstance.get(`${ApiEndpoints.MERCHANTS}/${guid}`).then((data) => data.merchant)
  }
}
